import React from 'react';
import './Product.css';
import { useStateValue } from './StateProvider';

function Product(props) {
  const [{ basket }, dispatch] = useStateValue();
  const addToBasket = () => {
    dispatch({
      type: 'ADD_TO_BASKET',
      item: {
        id: props.id,
        title: props.title,
        image: props.image,
        price: props.price,
        rating: props.rating,
      },
    });
  };
  return (
    <div className="product">
      <div className="product-info">
        <p>{props.title}</p>
        <p className="product-price">
          <small>₹ </small>
          <strong>{props.price}</strong>
        </p>
        <div className="product-rating">
          {Array(props.rating)
            .fill()
            .map((_) => (
              <p>⭐</p>
            ))}
        </div>
      </div>
      <img src={props.image} alt={props.title} />
      <button onClick={addToBasket}>Add to cart</button>
    </div>
  );
}

export default Product;
